<template>
  <div class="container bg-white mx-auto grid lg:grid-flow-col auto-cols-auto gap-16">
    <div class="text mx-auto">
      <p class="mx-8 hidden md:block crumb">
        <NuxtLink to="/">Home</NuxtLink> /
        <NuxtLink to="/learn/">Learn</NuxtLink> /
        <NuxtLink to="/learn/blogs/">Blogs</NuxtLink>
      </p>

      <h1 v-text="pageData.title"></h1>

      <div v-html="pageData.description"></div>

      <form id="search" class="my-8">
        <input type="text" id="search-field" placeholder="Search" v-model="search"/>
        <input type="submit" id="search-submit" value="" @click.stop.prevent="searchSubmit()" />
      </form>

      <!-- Ask the expert form -->
      <h2>Have a question? <span class="response">Ask the expert!</span></h2>

        <form action="" class="mt-4">
          <div v-if="errors.length" class="red">
            <b>Please correct the following error(s):</b>
            <ul>
              <li class="red" v-for="(error, index) in errors" :key="index">
                {{ error }}
              </li>
            </ul>
          </div>

          <div class="grid grid-cols-2 gap-3">
            <input
              type="text"
              v-model="fname"
              name="firstname"
              placeholder="First Name *"
              class="w-full"
              required
            />

            <input
              type="text"
              v-model="lname"
              name="lastname"
              placeholder="Last Name *"
              class="w-full"
              required
            />
          </div>

          <div class="relative">
            <input
              type="text"
              v-model="street"
              name="address"
              placeholder="Street Address *"
              class="w-full"
              v-on:keyup="smartystreets"
              id="smartystreetsaddress"
              required
            />

            <ul id="us-autocomplete-pro-menu" style="display:none;">
              <li
                v-for="(result, index) in results"
                :key="index"
                v-on:click="selectAddress(result)"
              >
                {{ result.street_line }} {{ result.city }}, {{ result.state }},
                {{ result.zipcode }}
              </li>
            </ul>
          </div>

          <div class="grid grid-cols-3 gap-3">
            <input
              type="text"
              v-model="city"
              name="city"
              placeholder="City *"
              required
            />

            <select v-model="state" name="state" required>
              <option value="" disabled selected>State *</option>
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>

            <input
              type="text"
              v-model="zip"
              name="zip"
              placeholder="Zipcode *"
              required
            />
          </div>

          <div class="grid grid-cols-3 gap-3">
            <div class="col-span-2">
              <input
                type="email"
                v-model="email"
                name="email"
                placeholder="Email Address *"
                class="w-full"
                required
              />
            </div>

            <MaskInput
              type="text"
              :mask="PHONE_INPUT_MASK"
              placeholder="Phone Number *"
              autocomplete="tel"
              name="phonenumber"
              v-model="phone"
              class="w-full"
              required
            />
          </div>

          <textarea
            v-model="comments"
            name="comments"
            placeholder="Add a comment or question"
            class="w-full h-36"
          ></textarea>

          <div class="flex justify-center md:justify-start">
            <label class="checkbox" for="allowText" >
              <span class="checkbox__input">
                <input
                  type="checkbox"
                  id="allowText"
                  name="allowText"
                  v-model="allowText"
                />
                <span class="checkbox__control">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      d="M1.73 12.91l6.37 6.37L22.79 4.59"
                    />
                  </svg>
                </span>
              </span>
              <p class="text-sm my-2">
                By checking this box, you agree to receive text messages (e.g. promotions, service notifications/reminders) from Spring Green at the number provided and consent to the monitoring and storage of the conversation.
                Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available). HELP for assistance.
                See our <NuxtLink to="/policies/privacy-policy/" target="_blank">Privacy Policy</NuxtLink> and our <NuxtLink to="/policies/terms-use/" target="_blank">Terms of Use</NuxtLink>.
              </p>
            </label>
          </div>

          <button
            type="submit"
            class="md:w-3/12 my-6"
            @click.stop.prevent="formSubmit()"
            :disabled="isFormSubmitProcessing"
            :class="{ 'opacity-50 cursor-not-allowed': isFormSubmitProcessing }"
          >
            <span v-if="!isFormSubmitProcessing">Submit</span>
            <span v-else>Submitting...</span>
          </button>
        </form>
      <!-- End Ask the Expert form -->

      <div
        v-for="post in posts"
        :key="post.id"
        class="grid grid-cols-3 gap-4 mb-6 postlist"
      >
        <div class="col-span-3 sm:col-span-1">
          <img loading="lazy" v-if="post.featured_image !== null"
            :src="
              `${urlLocation}${post.featured_image}`
            "
            :alt="post.title"
            class="float-left mr-4 mb-4 round-image blog-image"
          />
        </div>
        <div class="col-span-3 sm:col-span-2">
          <h2>{{ post.title }}</h2>
          <p v-html="stripContent(post.content)"></p>
          <p><NuxtLink :to="`/learn/blogs/${post.slug}/`" class="font-bold">Learn More ></NuxtLink></p>
        </div>
      </div>

      <!-- Add Pagination here -->
      <div class="flex justify-between font-bold m-4">
        <div>
          <NuxtLink v-if="prevPage > 0" :to="`/learn/blogs?page=${prevPage}`"> &#60; Prev</NuxtLink>
        </div>
        <div>
          <NuxtLink v-if="nextPage <= lastPage" :to="`/learn/blogs?page=${nextPage}`">Next ></NuxtLink>
        </div>
      </div>
    </div>

    <Sidebar :tags="tags" class="hidden md:block"/>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed, watchEffect } from 'vue';
import { useStore } from "vuex";
import type { Store } from 'vuex/types/index.js';
import type State from '~/domains/store/State';
import { MaskInput } from "vue-3-mask";
import { getPhoneParts, isPhoneNumberValid, PHONE_INPUT_MASK } from "~/utils/phone";
import { useReCaptcha } from "vue-recaptcha-v3";
import Swal from 'sweetalert2';
import type { SmartyStreetsLookupResult } from '~/domains/smartystreets/SmartyStreetsLookupResult';
import type { SmartyStreetsLookupSuggestion } from '~/domains/smartystreets/SmartyStreetsLookupSuggestion';
import { useSeoHead, buildItemListSchema } from '~/composables/useSeo';

const { $axios, $config, $sg, $leads, $st } = useNuxtApp();
const router = useRouter();
const route = useRoute();
const runtimeConfig = useRuntimeConfig();
const store: Store<State> = useStore();
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

const tags = ref<any[]>([]);
const search = ref("");
const results = ref<SmartyStreetsLookupSuggestion[]>([]);
const errors = ref<string[]>([]);
const posts = ref<any[]>([]);
const prevPage = ref(0);
const nextPage = ref(0);
const lastPage = ref(0);
const urlLocation = ref($config.public.sgCmsImage);
const fname = ref("");
const lname = ref("");
const street = ref("");
const city = ref("");
const state = ref("");
const zip = ref("");
const email = ref("");
const phone = ref("");
const allowText = ref(false);
const comments = ref("");
const isFormSubmitProcessing = ref(false);

// SSR-friendly data fetch for page content
const { data: pageData } = await useAsyncData(
  "blogs-page-content",
  () => $sg.getOctoberData('blog/landingpagecontent'),
  { default: () => ({}) }
);

// Compute frontend URL for structured data
const frontEndUrl = computed(() =>
  (runtimeConfig.public?.frontEndUrl || "https://www.spring-green.com").replace(/\/$/, "")
);

// Build ItemList structured data for blog posts when available
const itemListSD = computed(() => {
  if (!posts.value?.length) return null;
  return buildItemListSchema({
    name: "Spring-Green Blog",
    description: pageData.value?.meta_description || "Lawn care, pest control, and tree care tips from Spring-Green experts",
    items: posts.value.slice(0, 10).map((post: any) => ({
      name: post.title,
      url: `${frontEndUrl.value}/learn/blogs/${post.slug}/`,
    })),
  });
});

// Apply SEO head - runs on SSR and updates when itemListSD changes
watchEffect(() => {
  useSeoHead({
    title: pageData.value?.seo_title || "Lawn Care Blog | Spring-Green",
    description: pageData.value?.meta_description ||
      "For more than 45 years, Spring Green has been providing professional lawn care, pest control and tree care services. Visit www.spring-green.com to learn more about our dedication to quality.",
    openGraph: {
      title: pageData.value?.social_title || pageData.value?.seo_title || "Lawn Care Blog | Spring-Green",
      description: pageData.value?.social_description || pageData.value?.meta_description,
      type: "website",
    },
    structuredData: [
      itemListSD.value,
      pageData.value?.structured_data,
    ].filter(Boolean),
  });
});

const recaptcha = async () => {
  await recaptchaLoaded(); 
  return await executeRecaptcha("contact"); 
};

const fetchBlogPosts = async () => {
  const searchQuery = route.query.search;
  const tag = route.query.tag;
  const page = route.query.page ?? 1;

  const blogPosts = {
    currentPage: 0,
    lastPage: 0,
    data: [],
  };

  try {
    if (searchQuery) {
      const searchResponse = await $axios.post(
        `${$config.public.sgCmsApi}blog/search`,
        { search: searchQuery }
      );
      blogPosts.data = searchResponse?.data?.[0] ?? [];
    } else if (tag) {
      const tagResponse = await $axios.get(`${$config.public.sgCmsApi}tags/${tag}`);
      blogPosts.data = tagResponse?.data ?? [];
    } else if (page) {
      const pageResponse = await $axios.get(`${$config.public.sgCmsApi}posts?page=${page}`);
      if (pageResponse?.data) {
        blogPosts.currentPage = pageResponse.data.current_page;
        blogPosts.lastPage = pageResponse.data.last_page;
        blogPosts.data = pageResponse.data.data ?? [];
      }
    }
  } catch (err) {
    console.error(err);
  }

  const tagsData = await $axios.get($config.public.sgCmsApi + "tags").then(response => response.data).catch(error => ({ error: error, response: error.response.data }));

  posts.value = blogPosts.data;
  prevPage.value = blogPosts.currentPage - 1;
  nextPage.value = blogPosts.currentPage + 1;
  lastPage.value = blogPosts.lastPage;
  tags.value = tagsData;
};

const smartystreets = async () => {
  if (street.value.length > 0) {
    const resultsData: SmartyStreetsLookupResult = await $st.lookup(street.value);
    if (Object.keys(resultsData).length > 0) {
      results.value = resultsData.suggestions;
      document.getElementById("us-autocomplete-pro-menu").style.display = "block";
    }
  } else {
    document.getElementById("us-autocomplete-pro-menu").style.display = "none";
  }
};

const stripContent = (str) => {
  return str.substring(0, 800).replace(/<\/?[^>]+>/gi, " ");
};

const selectAddress = (element) => {
  street.value = element.street_line;
  city.value = element.city;
  state.value = element.state;
  zip.value = element.zipcode;
  document.getElementById("us-autocomplete-pro-menu").style.display = "none";
};

const searchSubmit = () => {
  router.push(`/learn/blogs?search=${search.value}`);
};

const formSubmit = async () => {
  isFormSubmitProcessing.value = true;
  errors.value = [];

  if (!fname.value) errors.value.push("First Name Required");
  if (!lname.value) errors.value.push("Last Name Required");
  if (!email.value) errors.value.push("Email required.");
  else if (!validEmail(email.value)) errors.value.push("Valid email required.");
  if (!street.value) errors.value.push("Address required");
  if (!city.value) errors.value.push("City required");
  if (!state.value) errors.value.push("State required");
  if (!zip.value) errors.value.push("Zipcode required");
  if (!phone.value) {
    errors.value.push("Phone number required");
  } else if (!isPhoneNumberValid(phone.value)) {
    errors.value.push(`Phone number should be in the following format: ${PHONE_INPUT_MASK}`);
  }

  if (errors.value.length > 0) {
    isFormSubmitProcessing.value = false;
    return false;
  }

  const phoneParts = getPhoneParts(phone.value);

  const data = {
    firstName: fname.value,
    lastName: lname.value,
    emailAddress: email.value,
    areaCode: phoneParts?.areaCode ?? "",
    phonePrefix: phoneParts?.phonePrefix ?? "",
    phoneNumber: phoneParts?.phoneNumber ?? "",
    allowText: allowText.value,
    address: street.value,
    city: city.value.trim(),
    state: state.value,
    zipCode: zip.value,
    contactType: "ASK_HAROLD_CONTACT",
    status: "NOT_APPLICABLE",
    comments: comments.value
  };

  const token = await recaptcha(); 
  if (!token) {
    await Swal.fire({
      title: "Invalid reCAPTCHA.\nPlease try again.",
      icon: "warning",
      customClass: {
        popup: "swal2-border-radius",
        confirmButton: "swal2-border-radius",
      },
    });
    isFormSubmitProcessing.value = false;
    return false; 
  }

  let success = false;
  try {
    const form = await $leads.submitContactForm(data);
    success = !form.error && form.id > 0;
  } catch (err) {
    console.error(err);
  } finally {
    isFormSubmitProcessing.value = false;
    scrollToTop();
  }

  if (success) {
    await Swal.fire({
      title: "Form submitted successfully.",
      customClass: {
        popup: "swal2-border-radius",
        confirmButton: "swal2-border-radius",
      },
    });
    clearForm();
  } else {
    await Swal.fire({
      title: "There was an error processing your request.\n\nPlease try again later.",
      customClass: {
        popup: "swal2-border-radius",
        confirmButton: "swal2-border-radius",
      },
    });
  }
};

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const validEmail = (email: string) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

const clearForm = () => {
  fname.value = "";
  lname.value = "";
  street.value = "";
  city.value = "";
  state.value = "";
  zip.value = "";
  email.value = "";
  phone.value = "";
  comments.value = "";
  allowText.value = false;
};

watch(() => route.query, (newQuery, oldQuery) => {
  const newSearch = newQuery.search;
  const newTag = newQuery.tag;
  const newPage = newQuery.page ?? 1;

  if (newSearch !== oldQuery.search || newTag !== oldQuery.tag || newPage !== oldQuery.page) {
    fetchBlogPosts();
  }
}, { deep: true });

onMounted(() => {
  fetchBlogPosts();
});
</script>

<style scoped>
.crumb {
  margin: 2rem 0 0;
}

#search {
  position: relative;
}

#search-field {
  width: 100%;
  border: 1px solid #b9b9b9;
  border-radius: 8px;
  padding: 12px 0 12px 50px;
  margin: 0;
}

#search-submit {
  background: #fff url(~/assets/images/search.png) no-repeat;
  border: none;
  display: block;
  height: 24px;
  width: 23px;
  position: absolute;
  top: 13px;
  left: 15px;
  cursor: pointer;
  padding: 0;
  border-radius: 0;
}

.blog-image {
  object-fit: cover;
  height: 250px;
}

h1{
  font-size: 32px;
}

.response {
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  color: #00810e;
  /* Ask The Expert! */
}

button {
  width: 100%;
  max-width: 300px;
  height: 40px;
  background: #00810e;
  border-radius: 100px;
  font-family: Poppins;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #ffffff;
}

.checkbox {
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
}

.checkbox__control {
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid #00810e;
  background: #fff;
  color: white;
  margin-top: -3px;
}

.checkbox__control svg {
  transition: transform 0.1s ease-in 25ms;
  transform: scale(0);
  transform-origin: bottom left;
}

.checkbox__input {
  display: grid;
  grid-template-areas: "checkbox";
}

.checkbox__input input {
  opacity: 0;
  width: 0;
  height: 0;
}

.checkbox__input input:checked + .checkbox__control svg {
  transform: scale(1);
}

.checkbox__input input:checked + .checkbox__control {
  background: #00810e;
}
</style>
